<div class="p-card" style="overflow: hidden; height: 100%;">

  <div *ngIf="activeTab === 'report'" style="overflow: auto; height: 100%;">

    <div style="overflow: hidden; height: 100%;">
      <div class="p-card-header flex p-3 gap-2 align-items-center">
        <h3 class="mr-3">Trust Report</h3>
        <p-select *ngIf="trustReport && trustReports"
                  [options]="trustReports"
                  optionLabel="name"
                  [ngModel]="trustReport"
                  (ngModelChange)="onTrustReportChanged($event)">
        </p-select>
      </div>
      <div class="scrollable-step-content" style="display: flex; flex-direction: column;" id="sapProfileLayoutDiv"
           *ngIf="trustReport" [formGroup]="formGroup">
        <div class="report-view">
          <h1>{{ formGroup.value.title }}</h1>
          <h3>{{ formGroup.value.subtitle }}</h3>

          <!-- Frameworks -->
          <h2 class="smaller-h2">Compliance Frameworks Covered:</h2>

          <h3 style="font-size: 50px; font-weight: bold; margin-top: 35px;">Controls Implementation</h3>

          @if (getSelectedFrameworks().length) {
            <div class="frameworks">
              <img *ngFor="let f of getSelectedFrameworks()"
                   [src]="f.value.imageUrl"
                   [alt]="f.value.name"
                   class="framework-image" />
            </div>
          }

          <!-- Categories -->
          <div class="categories" *ngFor="let category of getSelectedControlCategories()">
            <ng-container *ngIf="hasResponses(category)">
              <div class="category-bubble">
                <h2>{{ category.get('name')?.value }}</h2>

                <div class="control-item" *ngFor="let ci of getControlItemsControls(category)">
                  <div class="control-item-content"
                       *ngIf="ci.get('customResponse')?.value || ci.get('response')?.value">
                    <div class="control-item-header">
                      <strong>{{ ci.get('title')?.value }}</strong>
                    </div>
                    <div class="control-item-body">
                      <p>{{ ci.get('description')?.value }}</p>
                      <div class="status-indicator">
                        <ng-container *ngIf="ci.get('response')?.value">
                              <span *ngIf="ci.get('response')?.value === 'Custom' && ci.get('customResponse')?.value">
                                {{ ci.get('customResponse')?.value }}
                              </span>
                          <ng-container *ngIf="ci.get('response')?.value !== 'Custom'">
                            <span *ngIf="ci.get('response')?.value === 'Yes'" class="circle green"></span>
                            <span *ngIf="ci.get('response')?.value === 'N/A'" class="circle gray"></span>
                            <span *ngIf="ci.get('response')?.value === 'No'" class="circle red"></span>
                          </ng-container>
                        </ng-container>

                        <div *ngIf="ci.get('showNote')?.value && ci.get('note')?.value" class="note-display">
                          <em>{{ ci.get('note')?.value }}</em>
                        </div>
                      </div>


                    </div>

                    <div *ngIf="ci.get('evidences')?.value?.length" class="evidence-view mt-2">
                      <strong>Evidence:</strong>
                      <ul>
                        <li *ngFor="let ev of ci.get('evidences')?.value">
                          <ng-container *ngIf="ev.base64Data">
                            <a href="data:{{ev.mimeType}};base64,{{ev.base64Data}}"
                               download="{{ev.name}}">
                              {{ ev.name }}
                            </a>
                          </ng-container>
                        </li>
                      </ul>
                    </div>


                  </div>
                </div>
              </div>
            </ng-container>
          </div>

          <h3 style="font-size: 50px; font-weight: bold; margin-top: 35px;">Documentation</h3>
          <div class="category-bubble">
            <div>
              <div class="personnel-row no-page-break">
                <div class="personnel-info-cell no-page-break">
                  <div class="control-item">
                    <div class="control-item-content">
                      <div class="control-item-header"><strong>Policies &amp; Procedures</strong></div>
                      <div>
                        {{ trustReport.policiesAndProceduresNote }}
                      </div>
                      <div
                        style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                        @for (file of policiesAndProcedures; track file.name) {
                          <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                            <a target="_blank"
                               [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                               style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                        <span
                                          style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                              style="flex: 0 0 auto;">.{{ file.extension }}</span>
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="personnel-row no-page-break">
                <div class="personnel-info-cell no-page-break">
                  <div class="control-item">
                    <div class="control-item-content">
                      <div class="control-item-header"><strong>Assessments &amp; Authorizations</strong></div>
                      {{ trustReport.assessmentsAndAuthorizationsNote }}
                      <div
                        style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                        @for (file of assessmentsAndAuthorizations; track file.name) {
                          <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                            <a target="_blank"
                               [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                               style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                        <span
                                          style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                              style="flex: 0 0 auto;">.{{ file.extension }}</span>
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="personnel-row no-page-break">
                <div class="personnel-info-cell no-page-break">
                  <div class="control-item">
                    <div class="control-item-content">
                      <div class="control-item-header"><strong>Security Plans</strong></div>
                      {{ trustReport.securityPlansNote }}
                      <div
                        style="display: flex; flex-direction: row; flex-wrap: wrap; justify-content: space-between;">
                        @for (file of securityPlans; track file.name) {
                          <div style="display: flex; flex: 0 0 33%; overflow-x: hidden;">
                            <a target="_blank"
                               [attr.href]="'/api/documents/downloadFileWithPermanentToken?token=' + window.encodeURIComponent(file.permanentToken)"
                               style="display: inline-flex; flex: 0 0 auto; max-width: 100%; white-space: nowrap; justify-content: flex-start;">
                                      <span
                                        style="flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis;">{{ file.rawName }}</span><span
                              style="flex: 0 0 auto;">.{{ file.extension }}</span>
                            </a>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="control-item">
              <div class="control-item-content">
                <div class="control-item-header"><strong>
                  @if (trustReport.planOfActionAndMilestones) {
                    <a
                      [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.planOfActionAndMilestones) + '&tenantName=' + tenantName">
                      Plan of Action &amp; Milestones
                    </a>
                  } @else {
                    Plan of Action &amp; Milestones
                  }
                </strong></div>
                <div>
                  {{ trustReport.planOfActionAndMilestonesNote }}
                </div>
                <div>
                  @if (trustReport.planOfActionAndMilestones) {
                    <img style="max-width: 1200px;"
                         [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.planOfActionAndMilestones) + '&asImage=true&tenantName=' + tenantName" />
                  }
                </div>
              </div>
            </div>

            <div class="control-item">
              <div class="control-item-content">
                <div class="control-item-header"><strong>
                  @if (trustReport.incidentReports) {
                    <a
                      [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.incidentReports) + '&tenantName=' + tenantName">
                      Incident Reports
                    </a>
                  } @else {
                    Incident Reports
                  }
                </strong></div>
                <div>
                  {{ trustReport.incidentReportsNote }}
                </div>
                <div>
                  @if (trustReport.incidentReports) {
                    <img style="max-width: 1200px;"
                         [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.incidentReports) + '&asImage=true&tenantName=' + tenantName" />
                  }
                </div>
              </div>
            </div>

            <div class="control-item">
              <div class="control-item-content">
                <div class="control-item-header"><strong>
                  @if (trustReport.listOfDeployedAuthorizedServices) {
                    <a
                      [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.listOfDeployedAuthorizedServices) + '&tenantName=' + tenantName">
                      List of Deployed Authorized Services
                    </a>
                  } @else {
                    List of Deployed Authorized Services
                  }
                </strong></div>
                <div>
                  {{ trustReport.listOfDeployedAuthorizedServicesNote }}
                </div>
                <div>
                  @if (trustReport.listOfDeployedAuthorizedServices) {
                    <img style="max-width: 1200px;"
                         [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.listOfDeployedAuthorizedServices) + '&asImage=true&tenantName=' + tenantName" />
                  }
                </div>
              </div>
            </div>

            <div class="control-item">
              <div class="control-item-content">
                <div class="control-item-header"><strong>
                  @if (trustReport.additionalInformation) {
                    <a
                      [href]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.additionalInformation) + '&tenantName=' + tenantName">
                      Additional Information
                    </a>
                  } @else {
                    Additional Information
                  }
                </strong></div>
                <div>
                  {{ trustReport.additionalInformationNote }}
                </div>
                <div>
                  @if (trustReport.additionalInformation) {
                    <img style="max-width: 1200px;"
                         [attr.src]="api + '/api/attachments/publicFile?name='+ window.encodeURIComponent(trustReport.additionalInformation) + '&asImage=true&tenantName=' + tenantName" />
                  }
                </div>
              </div>
            </div>
          </div>

          <h3 style="font-size: 50px; font-weight: bold; margin-top: 35px;">Responsible Parties</h3>
          <div class="personnel-grid no-page-break category-bubble">

            <div class="personnel-row no-page-break" *ngFor="let section of [
    { title: 'Company Owners', data: formGroup.value.personnel.companyOwners },
    { title: 'Compliance Advisors', data: formGroup.value.personnel.complianceAdvisors },
    { title: 'Third Party Assessor/Auditor', data: formGroup.value.personnel.thirdPartyAssessors }
  ]">

              <div class="personnel-logo-cell no-page-break">
                <img [src]="section.data.imageUrl || 'assets/placeholder.png'"
                     alt="{{ section.title }} Logo"
                     class="personnel-logo" />
              </div>

              <div class="personnel-info-cell no-page-break">
                <h3>{{ section.title }}</h3>
                <div *ngFor="let p of section.data.people">
                  {{ p.name }}: {{ p.role }}
                </div>
              </div>

            </div>
          </div>


          <div class="report-disclaimer" *ngIf="formGroup.get('disclaimer')?.value">
            <hr />
            <p><strong>Disclaimer:</strong> {{ formGroup.get('disclaimer')?.value }}</p>
          </div>
          <div class="report-footer no-page-break" style="text-align: center; margin-top: 50px;">
            <img src="../../../assets/icon/favicon-96x96.png" alt="Rizkly Logo"
                 style="height: 40px; margin-bottom: 5px;" />
            <div>Powered by Rizkly</div>
            <div>Generated on {{ today | date:'MM/dd/yy' }}</div>
          </div>
          <br />
        </div>
        <div class="actions">
          <button mat-raised-button (click)="saveAsPDF()">Save to PDF</button>
          <button mat-raised-button (click)="saveAsHTMLZip()">Save to HTML Zip</button>
        </div>
        <br />
      </div>
    </div>
  </div>
</div>
